import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { cancel, later } from '@ember/runloop';
import zft from 'garaje/utils/zero-for-tests';

const COPIED_RESET_MS = 2000;

export default class InstructionsModalComponent extends Component {
  @tracked copied = false;

  _resetTimer = null;

  @action
  onCopySuccess() {
    this.copied = true;
    if (this._resetTimer) {
      cancel(this._resetTimer);
    }
    this._resetTimer = later(
      this,
      () => {
        this.copied = false;
        this._resetTimer = null;
      },
      zft(COPIED_RESET_MS),
    );
  }

  willDestroy() {
    super.willDestroy();
    if (this._resetTimer) {
      cancel(this._resetTimer);
    }
  }
}
